<template lang="pug">
  .carousel
    v-carousel.elevation-0(
      hide-controls
      height="100%"
      :interval="interval"
    )
      v-carousel-item.carousel__item(v-for="(item, index) in carouselCard" :key="index")
        slot(name="renderItem" :renderItem="item")
</template>

<script>

export default {
  name: 'Carousel',
  props: {
    items: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 8,
    },
    interval: {
      type: [Number, String],
      default: 10000,
    },
  },
  computed: {
    carouselCard() {
      const cardsArray = [];
      for (let cards = 0; cards < this.items.length; cards += this.perPage) {
        cardsArray.push(this.items.slice(cards, cards + this.perPage));
      }
      return cardsArray;
    },
  },
};
</script>

<style lang="sass">
  .carousel
    height: 100%
    width: 100%
    position: absolute
    left: 0vh

  .carousel .carousel__item
    height: 100%
    width: 100%
  .carousel .v-carousel__controls
    background: transparent
    height: 4vh
    .v-item-group > button
      color: white
</style>



// WEBPACK FOOTER //
// src/app/Dashboard/components/Carousel.vue